"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ListItemAvatar.default;
  }
});

var _ListItemAvatar = _interopRequireDefault(require("./ListItemAvatar"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/ListItemAvatar/index.js
// module id = 861
// module chunks = 0